var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { apiSlice, useGetAllMenuQuery, useGetCurrentUserQuery, useGetFileToDownloadQuery, useSaveWidgetPreferencesMutation, } from "@/store/api";
import { ListDivider, Menu, MenuItem } from "@mui/joy";
import { MenuButton } from "@mui/base";
import Dropdown from "@mui/joy/Dropdown";
import { useEffect, useMemo } from "react";
import { clearTokenUser, fetchCurrentUserThunk, } from "@/store/authSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { useNavigate } from "react-router";
import { endEditLayout, startEditlayout } from "@/store/layoutSlice";
import React from "react";
import { Slot } from "@/utils/types/layout";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import { useTranslation } from "react-i18next";
import { stripBasename } from "../forms/components/utils";
import { useLocation } from "react-router-dom";
// eslint-disable-next-line import/no-anonymous-default-export
var profileMenu = function ProfileMenu() {
    var _this = this;
    var t = useTranslation(["Common"]).t;
    var location = useLocation();
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var currentUrl = window.location.href;
    var queryResult = useGetCurrentUserQuery(null, {
        refetchOnMountOrArgChange: true,
    }).data;
    //const user = queryResult?.data?.record?.attributes;
    var currentUser = useAppSelector(getCurrentUser);
    var user = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes;
    useEffect(function () {
        if (!user) {
            // Si `user` n'est pas encore récupéré, déclenche l'action pour récupérer l'utilisateur
            dispatch(fetchCurrentUserThunk()).catch(function (error) {
                console.error("Erreur lors de la récupération de l'utilisateur:", error);
                throw error;
            });
        }
    }, [dispatch, user]);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var layout = useAppSelector(function (state) { return state.layout.slots; });
    var _a = useSaveWidgetPreferencesMutation(), saveWidgetPreferences = _a[0], _b = _a[1], isLoading = _b.isLoading, isSuccess = _b.isSuccess, isError = _b.isError, data = _b.data;
    useEffect(function () {
        //sessionStorage.setItem("lastVisitedUrl", window.location.pathname);
        if (location.pathname === "/login")
            return;
        var cleanPath = stripBasename(location.pathname);
        var last = sessionStorage.getItem("lastVisitedUrl");
        if (last !== cleanPath) {
            sessionStorage.setItem("lastVisitedUrl", cleanPath);
        }
    }, [location.pathname]);
    //const { data: queryResult } = useGetCur rentUserQuery(null);
    var _c = useGetAllMenuQuery(null), menuResult = _c.data, menuIsLoading = _c.isLoading;
    var handleSaveWidgets = function () { return __awaiter(_this, void 0, void 0, function () {
        var docks, widgets, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    docks = [
                        Slot.HEADER_START,
                        Slot.HEADER_CENTER,
                        Slot.HEADER_END,
                        Slot.MENU_NORTH,
                        Slot.MENU_WEST,
                        Slot.MENU_EAST,
                        Slot.DOCK_WEST,
                        Slot.DOCK_EAST,
                        Slot.DOCK_NORTH,
                        Slot.DOCK_SOUTH,
                        Slot.FOOTER_START,
                        Slot.FOOTER_CENTER,
                        Slot.FOOTER_END,
                    ];
                    widgets = docks.reduce(function (acc, slot) {
                        var _a;
                        var slotWidgets = ((_a = layout[slot]) === null || _a === void 0 ? void 0 : _a.widgets) || [];
                        return acc.concat(slotWidgets);
                    }, []);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveWidgetPreferences(widgets).unwrap()];
                case 2:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Failed to save widgets:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _d = useGetFileToDownloadQuery({
        params: {
            id: user === null || user === void 0 ? void 0 : user.id,
            type: "Users",
            isTempFile: false,
            tempName: user === null || user === void 0 ? void 0 : user.photo,
            isRecordFile: true,
        },
    }), file = _d.data, error = _d.error;
    var initials = useMemo(function () {
        var initials = (user === null || user === void 0 ? void 0 : user.first_name[0]) || "" + (user === null || user === void 0 ? void 0 : user.last_name[0]) || "";
        return initials.toUpperCase();
    }, [user === null || user === void 0 ? void 0 : user.last_name, user === null || user === void 0 ? void 0 : user.first_name]);
    var currentUserProfile = useMemo(function () {
        var _a, _b;
        return ((_b = (_a = menuResult === null || menuResult === void 0 ? void 0 : menuResult.data) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.profile) || [];
    }, [menuResult]);
    var profileMenus = useMemo(function () {
        var _a, _b;
        var links = (_b = (_a = menuResult === null || menuResult === void 0 ? void 0 : menuResult.data) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.links;
        if (!links)
            return [];
        return Object.keys(links).map(function (id) {
            var _a;
            var entry = __assign({}, links[id]);
            entry.nativeURL = entry.url;
            var url = new URL(entry.url, (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
            var module = url.searchParams.get("module") || "";
            var action = url.searchParams.get("action") || "";
            var record = url.searchParams.get("record") || "";
            entry.url = module ? "/modules/".concat(module) : "";
            entry.url +=
                action && action.toLocaleLowerCase() !== "index" ? "/".concat(action) : "";
            entry.url += record ? "/".concat(record) : "";
            return __assign({ id: id }, entry);
        });
    }, [menuResult]);
    /*
    if (queryResult?.status !== RequestStatus.SUCCESS) {
      return <></>;
    }
    */
    if (!user) {
        return _jsx(_Fragment, {});
    }
    var isMatchingUrl = currentUrl.includes("/modules/Administration") ||
        currentUrl.includes("/modules/Configurator") ||
        currentUrl.includes("/modules/ModuleBuilder") ||
        currentUrl.includes("/modules/SecurityGroups");
    return (_jsxs(Dropdown, { children: [_jsx(MenuButton, { children: _jsx("span", __assign({ className: "flex items-center justify-center w-8 h-8 mx-4 overflow-hidden bg-white rounded-full" }, { children: (user === null || user === void 0 ? void 0 : user.photo) ? _jsx("img", { src: "".concat(file === null || file === void 0 ? void 0 : file.data.output) }) : initials })) }), !menuIsLoading && (_jsxs(Menu, { children: [currentUserProfile && (_jsx(MenuItem, __assign({ onClick: function () { return navigate("/".concat(currentUserProfile === null || currentUserProfile === void 0 ? void 0 : currentUserProfile.url)); } }, { children: currentUserProfile === null || currentUserProfile === void 0 ? void 0 : currentUserProfile.label }))), profileMenus &&
                        profileMenus.map(function (menu) { return (_jsx(MenuItem, __assign({ onClick: function () { return navigate(menu.url); } }, { children: menu.label }), menu.id)); }), !isMatchingUrl && _jsx(ListDivider, {}), !isEditingLayout && !isMatchingUrl && (_jsx(MenuItem, __assign({ onClick: function () {
                            dispatch(startEditlayout());
                        } }, { children: t("app.LBL_EDIT_LAYOUT", { ns: "Common" }) }))), isEditingLayout && (_jsx(MenuItem, __assign({ onClick: function () {
                            dispatch(endEditLayout());
                            handleSaveWidgets();
                        } }, { children: t("app.LBL_END_EDIT_LAYOUT", { ns: "Common" }) }))), _jsx(ListDivider, {}), _jsx(MenuItem, __assign({ onClick: function () {
                            //dispatch(clearToken());
                            dispatch(clearTokenUser());
                            dispatch(apiSlice.util.resetApiState());
                        } }, { children: t("app.LBL_LOGOUT", { ns: "Common" }) }))] }))] }));
};
export default React.memo(profileMenu);
